import { post, postFile, postExFile, getExFile } from "@utils/httpUtil";
export var IliveModeType;
(function (IliveModeType) {
  IliveModeType["SPEAKER"] = "SPEAKER";
  IliveModeType["GUEST"] = "GUEST";
})(IliveModeType || (IliveModeType = {}));
export var ItransmissionSource;
(function (ItransmissionSource) {
  ItransmissionSource["WECHAT_MOMENTS"] = "WECHAT_MOMENTS";
  ItransmissionSource["WECHAT_FRIEND"] = "WECHAT_FRIEND";
})(ItransmissionSource || (ItransmissionSource = {}));
export var ItransmissionSourceName;
(function (ItransmissionSourceName) {
  ItransmissionSourceName["WECHAT_MOMENTS"] = "\u670B\u53CB\u5708";
  ItransmissionSourceName["WECHAT_FRIEND"] = "\u5FAE\u4FE1\u597D\u53CB";
})(ItransmissionSourceName || (ItransmissionSourceName = {}));
export var IContentRangeType;
(function (IContentRangeType) {
  IContentRangeType["CONTENT_TYPE"] = "CONTENT_TYPE";
  IContentRangeType["ASSIGN_CONTNET"] = "ASSIGN_CONTNET";
})(IContentRangeType || (IContentRangeType = {}));
export var IContentRangeTypeStatus;
(function (IContentRangeTypeStatus) {
  IContentRangeTypeStatus["CONTENT_TYPE"] = "CONTENT_TYPE";
  IContentRangeTypeStatus["ASSIGN_CONTNET"] = "ASSIGN_CONTNET";
})(IContentRangeTypeStatus || (IContentRangeTypeStatus = {}));
export var IInteractType;
(function (IInteractType) {
  IInteractType["COMMENT"] = "COMMENT";
  IInteractType["LIVE"] = "LIVE";
  IInteractType["QUESTIONNAIRE"] = "QUESTIONNAIRE";
  IInteractType["ANSWERQUESTIONS"] = "ANSWER_QUESTIONS";
  IInteractType["STUDY"] = "STUDY";
})(IInteractType || (IInteractType = {}));
export var IInteractTypeStatus;
(function (IInteractTypeStatus) {
  IInteractTypeStatus["COMMENT"] = "COMMENT";
  IInteractTypeStatus["LIVE"] = "LIVE";
  IInteractTypeStatus["QUESTIONNAIRE"] = "QUESTIONNAIRE";
  IInteractTypeStatus["ANSWER_QUESTIONS"] = "ANSWER_QUESTIONS";
  IInteractTypeStatus["STUDY"] = "STUDY";
})(IInteractTypeStatus || (IInteractTypeStatus = {}));
export var IUserSource;
(function (IUserSource) {
  IUserSource["CONDITIONAL"] = "CONDITIONAL";
  IUserSource["LIST_IMPORT"] = "LIST_IMPORT";
})(IUserSource || (IUserSource = {}));
export var IInteractTypeName;
(function (IInteractTypeName) {
  IInteractTypeName["COMMENT"] = "\u53D1\u5E03\u8BC4\u8BBA";
  IInteractTypeName["LIVE"] = "\u76F4\u64AD\u8BB2\u8BFE";
  IInteractTypeName["LIVE_TRANSMISSION"] = "\u76F4\u64AD\u8BB2\u8BFE";
  IInteractTypeName["QUESTIONNAIRE"] = "\u53C2\u4E0E\u95EE\u5377";
  IInteractTypeName["ANSWER_QUESTIONS"] = "\u53C2\u4E0E\u7B54\u9898";
  IInteractTypeName["STUDY"] = "\u5B66\u4E60\u5185\u5BB9";
})(IInteractTypeName || (IInteractTypeName = {}));
export var transmissionNodeName;
(function (transmissionNodeName) {
  transmissionNodeName["AUTO"] = "\u81EA\u52A8\u53D1\u5956";
  transmissionNodeName["MANUAL"] = "\u624B\u52A8\u53D1\u5956";
  transmissionNodeName["STUDY"] = "\u5B66\u4E60\u5185\u5BB9";
})(transmissionNodeName || (transmissionNodeName = {}));
export var IContentType;
(function (IContentType) {
  IContentType["ARTICLE"] = "ARTICLE";
  IContentType["LIVE"] = "LIVE";
})(IContentType || (IContentType = {}));
export var IContentTypeName;
(function (IContentTypeName) {
  IContentTypeName["ARTICLE"] = "\u6587\u7AE0";
  IContentTypeName["LIVE"] = "\u76F4\u64AD";
  IContentTypeName["ANSWER_QUESTIONS"] = "\u7B54\u9898";
  IContentTypeName["COURSE"] = "\u8BFE\u7A0B";
  IContentTypeName["QUESTIONNAIRE"] = "\u95EE\u5377";
})(IContentTypeName || (IContentTypeName = {}));
export var IActivityInteractType;
(function (IActivityInteractType) {
  IActivityInteractType["INTERACT"] = "INTERACT";
  IActivityInteractType["AUTHORIZATION"] = "AUTHORIZATION";
  IActivityInteractType["CONTRIBUTE"] = "CONTRIBUTE";
})(IActivityInteractType || (IActivityInteractType = {}));
export var IPriceType;
(function (IPriceType) {
  IPriceType["SAME_PRICE"] = "SAME_PRICE";
  IPriceType["TITLE_PRICE"] = "TITLE_PRICE";
  IPriceType["ASSIGN_PRICE"] = "ASSIGN_PRICE";
})(IPriceType || (IPriceType = {}));
export var IPriceTypeStatus;
(function (IPriceTypeStatus) {
  IPriceTypeStatus["SAME_PRICE"] = "\u7B49\u989D\u62A5\u4EF7";
  IPriceTypeStatus["TITLE_PRICE"] = "\u804C\u79F0\u62A5\u4EF7";
  IPriceTypeStatus["ASSIGN_PRICE"] = "\u5206\u5F00\u62A5\u4EF7";
})(IPriceTypeStatus || (IPriceTypeStatus = {}));
export var IAuditNodeStatus;
(function (IAuditNodeStatus) {
  IAuditNodeStatus["AUDIT"] = "\u5BA1\u6838\u53D1\u5956";
  IAuditNodeStatus["AUTO"] = "\u81EA\u52A8\u53D1\u5956";
})(IAuditNodeStatus || (IAuditNodeStatus = {}));
export const IInteractionsNum = {
  3: "1v1",
  4: "1v3",
  7: "1v6",
  10: "1v9",
  13: "1v12",
  16: "1v15"
};
export const IActiveType = {
  //  ARTICLE(0, "文章邀约"),
  //   SUBJECT(1, "专题邀约"),
  //   QUESTIONS_ANSWER(2, "问答邀约"),
  //   MEDICAL(3, "病例活动"),
  //   LEARNING(4, "学术任务"),
  //   INTERACT(5, "学术互动"),
  //   AUTHORIZATION(6, "学术授权");
  ARTICLE: "文章邀约",
  SUBJECT: "专题邀约",
  QUESTIONS_ANSWER: "问答邀约",
  MEDICAL: "病例邀约",
  LEARNING: "学术任务",
  INTERACT: "互动类",
  AUTHORIZATION: "授权类",
  CONTRIBUTE: "投稿类"
};
export function pageInteractActivity(data, config) {
  return post(`activity/center/page`, data, config);
}
// 互动活动详情
export function activityinteractDetail(data, config) {
  return post(`activity/interact/detail`, data, config);
}
// 互动活动详情
export function activityauthorizeDetail(data, config) {
  return post(`activity/authorize/detail`, data, config);
}
// 互动活动详情
export function activityContributeDetail(data, config) {
  return post(`activity/contribute/detail`, data, config);
}
// 结束活动
export function activityinteractEnd(data, config) {
  return post(`activity/interact/end`, data, config);
}
// 结束活动
export function activityauthorizeEnd(data, config) {
  return post(`activity/authorize/end`, data, config);
}
// 结束活动
export function activityContributeEnd(data, config) {
  return post(`activity/contribute/end`, data, config);
}
// 根据手机号查询邀请医生信息
export function activityinteractGetUserByPhone(data, config) {
  return post(`activity/center/getUserByPhone`, data, config);
}
// 导入指定报价
export function activityinteractImportAssignPrice(data, config) {
  return postFile(`activity/interact/importAssignPrice`, data, config);
}
// 导入医生
export function activityinteractImportDoctor(data, config) {
  return postFile(`activity/center/importDoctor`, data, config);
}
// 导入医生V2
export function activityinteractImportDoctorV2(data, config) {
  return postFile(`activity/center/importDoctorV2`, data, config);
}
// 匹配符合条件的医生
export function activityinteractMatchUser(data, config) {
  return post(`activity/center/matchUser`, data, config);
}
// // 分页查询互动活动列表
// export function activityinteractPageInteractActivity(data: Record<string | number, any>, config?: Record<string | number, any>) {
//   return post(`activity/interact/pageInteractActivity`, data, config);
// }
// 保存/修改互动活动
export function activityinteractSave(data, config) {
  return post(`activity/interact/save`, data, config);
}
// 保存/修改互动活动
export function activityauthorizeSave(data, config) {
  return post(`activity/authorize/save`, data, config);
}
// 保存/修改互动活动
export function activitycontributeSave(data, config) {
  return post(`activity/contribute/save`, data, config);
}
// 活动列表导出
export function exportActivityInteract(data, config) {
  return postExFile(`medicine/excel/exportActivityInteract`, data, config);
}
// 课程搜索
export function authorizeFindEsCourseAggregationPage(data, config) {
  return post(`activity/authorize/findEsCourseAggregationPage`, data, config);
}
// 互动内容明细列表
export function academicRecordPage(data, config) {
  return post(`academic/record/page`, data, config);
}
// b端后台授权活动明细列表
export function activityAuthorizePage(data, config) {
  return post(`activity/authorize/page`, data, config);
}
// 活动名称下拉列表
export function recordAcademicActivitySelect(data, config) {
  return post(`academic/record/academicActivitySelect`, data, config);
}
// 活动名称下拉列表
export function queryActivityName(data, config) {
  return post(`activity/center/queryActivityName`, data, config);
}
// 活动名称下拉列表
export function activityAuthorizeExport(data, config) {
  return postExFile(`activity/authorize/export`, data, config);
}
// 导出学术互动活动明细列表 已通过
export function academicRecordExport(data, config) {
  return postExFile(`academic/record/export`, data, config);
}
// 导出学术互动活动明细列表 拒绝
export function academicExportReject(data, config) {
  return postExFile(`academic/record/exportReject`, data, config);
}
// 导出学术互动活动明细列表 待审核
export function academicExportWaitSelect(data, config) {
  return postExFile(`academic/record/exportWaitSelect`, data, config);
}
// 批量通过/拒绝内容
export function academicRecordBatchOperate(data, config) {
  return post(`academic/record/batchOperate`, data, config || {
    ignoreError: true
  });
}
// 删除内容
export function academicRecordDelete(data, config) {
  return post(`academic/record/delete`, data, config);
}
// 删除内容
export function exportFailDoctorData(data, config) {
  return postExFile(`medicine/excel/exportFailDoctorData`, data, config);
}
export function activityExportFailExcelApi(data, config) {
  return getExFile(`activity/interact/exportFailExcel`, data, config);
}
//医生直播列表
export function interactFindLive(data, config) {
  return post(`activity/interact/findLive`, data, config);
}
//投稿类活动明细-待筛选
export function pageWaitSelect(data, config) {
  return post(`activity/contribute/pageWaitSelect`, data, config);
}
//投稿类活动明细-已采纳
export function pageAdopt(data, config) {
  return post(`activity/contribute/pageAdopt`, data, config);
}
//投稿类活动明细-已采纳
export function pageReject(data, config) {
  return post(`activity/contribute/pageReject`, data, config);
}
//投稿类活动明细-采纳投稿
export function contributeAdopt(data, config) {
  return post(`activity/contribute/adopt`, data, config || {
    ignoreError: true
  });
}
//投稿类活动明细-采纳投稿
export function contributeReject(data, config) {
  return post(`activity/contribute/reject`, data, config);
}
//投稿类活动明细-撤回拒绝投稿
export function contributeWithdraw(data, config) {
  return post(`activity/contribute/withdraw`, data, config);
}
//投稿类活动明细-删除投稿
export function contributeDelete(data, config) {
  return post(`activity/contribute/delete`, data, config);
}
//投稿类活动明细-导出-已采纳-待奖励
export function exportAdopt(data, config) {
  return postExFile(`activity/contribute/exportAdopt`, data, config);
}
//投稿类活动明细-导出-已采纳-已奖励
export function exportAdoptZip(data, config) {
  return postExFile(`activity/contribute/exportAdoptZip`, data, config);
}
//投稿类活动明细-导出-已采纳-已奖励
export function exportSelectZip(data, config) {
  return postExFile(`activity/contribute/exportSelectZip`, data, config);
}
//投稿类活动明细-导出-已采纳-已奖励
export function exportRejectZip(data, config) {
  return postExFile(`activity/contribute/exportRejectZip`, data, config);
}
//投稿类活动明细-导出-已采纳-已奖励
export function exportAdoptReward(data, config) {
  return postExFile(`activity/contribute/exportAdoptReward`, data, config);
}
//投稿类活动明细-导出-拒绝
export function exportReject(data, config) {
  return postExFile(`activity/contribute/exportReject`, data, config);
}
//投稿类活动明细-导出-待筛选
export function exportSelect(data, config) {
  return postExFile(`activity/contribute/exportSelect`, data, config);
}
//学习内容详情 导出数据
export function exportInviteUser(data, config) {
  return postExFile(`activity/interact/exportInviteUser`, data, config);
}
//投稿类活动明细-发放稿费
export function grantPaymentReward(data, config) {
  return post(`activity/contribute/grantPaymentReward`, data, config || {
    ignoreError: true
  });
}
//投稿类活动明细-发放传播费
export function grantTransmissionReward(data, config) {
  return post(`activity/contribute/grantTransmissionReward`, data, config || {
    ignoreError: true
  });
}
//互动类活动明细-发放传播费
export function authorizeGrantTransmissionReward(data, config) {
  return post(`activity/authorize/grantTransmissionReward`, data, config);
}
//医生直播列表
export function getQuestionnaireDetailList(data, config) {
  return post(`academic/getQuestionnaireDetail`, data, config);
}
//批量发奖
export function recordBatchReward(data, config) {
  return post(`academic/record/batchReward`, data, config || {
    ignoreError: true
  });
}
//暂存活动
export function saveOrUpdateActivityStash(data, config) {
  return post(`activity/saveOrUpdateActivityStash`, data, config);
}
//查询暂存活动
export function getActivityStash(data, config) {
  return post(`activity/getActivityStash`, data, config);
}
//保存/修改 自动采集文章配置信息
export function collectConfigSave(data, config) {
  return post(`activity/collect/config/save`, data, config);
}
//保存/修改 自动采集文章配置信息
export function collectConfigGetCollectConfig(data, config) {
  return post(`activity/collect/config/getCollectConfig`, data, config);
}